/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown> }} My_Grower_Report_WeekInputs */

const vi_my_grower_report_week = /** @type {(inputs: My_Grower_Report_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tuần ${i?.range}`)
};

/**

* @param {My_Grower_Report_WeekInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_week = /** @type {((inputs: My_Grower_Report_WeekInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_WeekInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_week(inputs)
});